// extracted by mini-css-extract-plugin
export var container = "styles-module--container--dbO9k";
export var body = "styles-module--body--fY5FE";
export var promotion = "styles-module--promotion--1YtGb";
export var formContainer = "styles-module--form-container--28YsQ";
export var contactForm = "styles-module--contact-form--4EeUj";
export var title = "styles-module--title--2_LGY";
export var mdx = "styles-module--mdx--1h7kC";
export var brandListTitle = "styles-module--brand-list-title--1igRM";
export var brandList = "styles-module--brand-list--1I6r0";
export var brand = "styles-module--brand--2_6ny";